import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './frontend.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('home');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleGetStarted = () => {
    setDrawerOpen(false);
    navigate('/account');
  };

  const handleNavClick = (sectionId, e) => {
    e.preventDefault();
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setDrawerOpen(false);
  };

  const handleBrandClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setActiveSection('home');
    setDrawerOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'how-it-works', 'pricing', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className="header-container">
        <div className="brand" onClick={handleBrandClick}>
          <span className="text-pink">HamaraBill</span>
          <span className="text-dark">Book</span>
        </div>

        <nav className="desktop-nav">
          {['home', 'about', 'how-it-works', 'pricing', 'contact'].map((id) => (
            <a
              key={id}
              href={`#${id}`}
              onClick={(e) => handleNavClick(id, e)}
              className={activeSection === id ? 'active' : ''}
            >
              {id.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
            </a>
          ))}
        </nav>

        <div className="get-started-desktop">
          <button onClick={handleGetStarted}>Get Started</button>
        </div>

        <div className="hamburger" onClick={() => setDrawerOpen(true)}>
          <FaBars size={24} />
        </div>
      </header>

      {/* Side Drawer */}
      <div className={`side-drawer ${drawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <div className="brand" onClick={handleBrandClick}>
            <span className="text-pink">HamaraBill</span>
            <span className="text-dark">Book</span>
          </div>
          <FaTimes className="close-icon" size={20} onClick={() => setDrawerOpen(false)} />
        </div>

        <nav className="drawer-nav">
          {['home', 'about', 'how-it-works', 'pricing', 'contact'].map((id) => (
            <a
              key={id}
              href={`#${id}`}
              onClick={(e) => handleNavClick(id, e)}
              className={activeSection === id ? 'active' : ''}
            >
              {id.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
            </a>
          ))}
        </nav>

        <button className="get-started-btn" onClick={handleGetStarted}>
          Get Started
        </button>
      </div>

      {/* Backdrop */}
      {drawerOpen && <div className="backdrop" onClick={() => setDrawerOpen(false)} />}
    </>
  );
};

export default Header;
